import consentModeList from './consentModeList';
import dateUnitList from './dateUnitList';
import frequencyUnitList from './frequencyUnitList';
import dataRangeList from './dataRangeList';
import { dataFilterTypes, dataFilterOperators } from './dataFilter';
import trackConsentColumns from './trackConsentColumns';
import userColumns from './userColumns';
import viewConsentColumns from './viewConsentColumns';
import userDetailsColumns from './userDetailsColumns';
import userRoleColumns from './userRoleColumns';
import userRoleDetailsColumns from './userRoleDetailsColumns';
import templateDetailColumns from './templateDetailColumns';
import templateColumns from './templateColumns';
import failedAccountColumns from './failedAccountColumns';
import initialCreateConsentRequestValues from './initialCreateRequestValues';
import initialConsentTemplateValues from './initialConsentTemplateValues';
import initialCreateUserValue from './initialCreateUserValues';
import initialCreateUserRoleValue from './initialCreateUserRoleValues';
import fraudMapping from './fraudIndicators';
import behaveMapping from './behaviouralIndicators';
import propertyOptions from './propertyOptions';
import {
	consentFilterOptions,
	customerFilterOptions,
	pfmCustomerFilterOptions,
} from './filterOptions';

const CONSTANTS = {
	frequencyUnitList,
	consentModeList,
	dateUnitList,
	dataRangeList,
	dataFilterTypes,
	dataFilterOperators,
	trackConsentColumns,
	viewConsentColumns,
	initialCreateConsentRequestValues,
	initialConsentTemplateValues,
	fraudMapping,
	behaveMapping,
	propertyOptions,
	consentFilterOptions,
	customerFilterOptions,
	pfmCustomerFilterOptions,
	initialCreateUserValue,
	initialCreateUserRoleValue,
	userColumns,
	userDetailsColumns,
	userRoleColumns,
	userRoleDetailsColumns,
	templateColumns,
	templateDetailColumns,
	failedAccountColumns,
};

export default CONSTANTS;
